import React from 'react'
import { blogDataList } from '../Data/More_Data/blogData';
import ProductSlider from './ProductSlider';

const BlogListingSlider = () => {
  // Function to truncate text with ellipsis
  const truncateText = (text, length) => {
    return text.length > length ? text.substring(0, length) + "..." : text;
  };

  const generateBlogCardHTML = (blogData) => {
    // Define default text lengths
    let titleLength = 35;
    let descLength = 105;

    // Adjust text lengths based on window width
    if (window.innerWidth < 265) {
      titleLength = 20;
      descLength = 50;
    } else if (window.innerWidth > 265 && window.innerWidth < 355) {
      titleLength = 20;
      descLength = 75;
    } else if (window.innerWidth > 355 && window.innerWidth < 387) {
      titleLength = 25;
      descLength = 85;
    } else if (window.innerWidth > 387 && window.innerWidth < 450) {
      titleLength = 20;
      descLength = 90;
    } else if (window.innerWidth > 450 && window.innerWidth < 768) {
      titleLength = 25;
      descLength = 90;
    } else if (window.innerWidth > 768 && window.innerWidth < 1300) {
      titleLength = 30;
      descLength = 100;
    }
    const title = truncateText(blogData.title, titleLength);
    const description = truncateText(blogData.description, descLength);

    return `
        <div class="swiper-slide">
            <div class="blog-card">
                <div class="blog-img">
                    <img loading="lazy" style="width: 100%; height: 200px; object-fit: cover;" src="${blogData.imageSrc}" alt="${blogData.altText}" title="${blogData.title}">
                </div>
                <div class="blog-content">
                    <div class="blog-meta">
                        <a href="javascript:void(0);">
                            <i class="fal fa-calendar-days"></i>
                            ${blogData.date}
                        </a>
                        <a href="javascript:void(0);">
                            <i class="fal fa-comments"></i>
                            ${blogData.comments} Comments
                        </a>
                    </div>
                    <h3 class="box-title">
                        <a href="${blogData.blogLink}">
                            ${title}
                        </a>
                    </h3>
                    <p class="blog-text">
                        ${description}
                    </p>
                    <div class="blog-bottom">
                        <a href="${blogData.blogLink}" class="line-btn">
                            Read More
                            <i class="fas fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        `;
  };

  const generateBlogSliderHTML = (blogDataList) => {
    return blogDataList.map(generateBlogCardHTML);
  };

  const blogHTMLData = generateBlogSliderHTML(blogDataList);

  return (
    <div>
      <section
        className="bg-top-right overflow-hidden space"
        id="blog-sec"
        style={{ backgroundImage: `url('assets/img/bg/blog_bg_1.png')` }}
        data-bg-src=""
        data-overlay="overlay1"
        data-opacity="1"
      >
        <div className="container">
          <div className="title-area text-center">
            <span className="sub-title">LATEST BLOGS</span>
            <h2 className="sec-title">
              Get Every Single Update
              <span className="text-theme fw-normal"> Blog</span>
            </h2>
          </div>
          <div className="slider-area">
            <ProductSlider cardData={blogHTMLData} slidesPerView={3} />
          </div>
        </div>
      </section>
    </div>
  );
}

export default BlogListingSlider
